import "./Footer.css";
import logoDark from "@assets/images/logo-dark.png";

/**
 * Footer component with SKEMA branding and contact information
 */
const Footer = () => {
  return (
    <footer className="new-footer">
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-partnership">
            <span className="partnership-text">Powered by</span>
            <img src={logoDark} alt="SKEMA Logo" className="footer-logo" />
          </div>
        </div>

        <div className="footer-right">
          <a
            href="mailto:rodolphe.desbordes@skema.edu"
            className="contact-email"
          >
            rodolphe.desbordes@skema.edu
          </a>
          <div className="copyright">
            &copy; 2025–{new Date().getFullYear()} ISCRI - SKEMA Business School
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;